function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const SpellcheckIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.052 19.684a1 1 0 0 0 1.897.632A969.633 969.633 0 0 0 7.679 12h5.933c.272.681.582 1.449.963 2.379a1 1 0 0 0 1.85-.758c-.499-1.22-.876-2.16-1.206-2.99l-.562-1.424-.227-.574c-.502-1.272-.867-2.248-1.15-3.001l-.06-.163c-.284-.755-.497-1.32-.686-1.714-.18-.376-.434-.814-.911-1.059-.394-.202-.832-.198-1.066-.196h-.104c-.218-.002-.63-.004-1.022.182-.464.22-.756.611-.982 1.029-.428.79-.927 2.283-1.802 4.98l-.473 1.462-.175.54a993.68 993.68 0 0 1-2.947 8.99ZM12.82 10H8.325l.224-.692c.909-2.802 1.341-4.06 1.658-4.644a1.72 1.72 0 0 1 .098-.161 5.17 5.17 0 0 1 .366-.001c.017.03.037.07.06.118.141.294.319.76.616 1.551l.061.164c.283.754.653 1.743 1.162 3.032l.25.633Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.606 21.447a1 1 0 0 0 1.662.193l5-6a1 1 0 0 0-1.536-1.28l-4.021 4.825-.816-1.632a1 1 0 1 0-1.79.894l1.5 3Z"
  }));
};
SpellcheckIcon.defaultProps = {
  size: 16,
  bg: 'currentColor'
};
export default SpellcheckIcon;